/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Helmet } from "react-helmet";
import Canonical from "../../../../components/common/layout/Canonical";
import { useTranslation } from "react-i18next";
import CorporateBanner from "../../../../components/common/form/CorporateBanner";
import { useEffect, useState } from "react";
import { useSitemap } from "../../../../shared/hooks/use-sitemap";
import useAxios from "../../../../shared/hooks/use-axios";
import { url } from "../../../../shared/utils/url";
import Error from "../../../../components/common/form/Error";
import PaginationComponent from "../../../../components/common/form/PaginationComponent";
import EmptyList from "../../../../components/common/form/EmptyList";
import { useSelector } from "react-redux";
import ModalVideo from 'react-modal-video';
// import { CloseBtn } from "../../../../components/common/svg/AllSvg";

const VideoGallery = () => {
    const { t } = useTranslation('common');
    const lang: string = useSelector((state: any) => state.ui.lang);
    const [selectIdx, setSelectIdx] = useState<any>(null);
    const [data, setData] = useState<any[]>([])
    const [loading, setLoading] = useState<boolean>(true)
    const [isError, setIsError] = useState<boolean>(false)
    const [page, setPage] = useState<number>(1);
    const [total, setTotal] = useState<number>(0);
    const [size, setSize] = useState<any>({ label: `10 ${t("recruitment.home.per_page")}`, value: "10" });
    let totalPages: number = Math.ceil(total / +size?.value);
    const loaderData: any[] = [1, 2, 3, 4, 5]
    useSitemap();

    const getVideoGallery = async () => {
        try {
            setLoading(true)
            setIsError(false)
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url.video_gallery}?page=${page}&size=${+size?.value}`);

            if (res && res.status === 200) {
                setData(res?.data?.results)
                setTotal(res?.data?.count)
                setLoading(false)
            }
        } catch (error) {
            setLoading(false)
            setIsError(true)
            console.error("error while fetching video gallery", error);
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        !!lang && getVideoGallery();
    }, [page, size, lang])

    useEffect(() => {
        if ((!!selectIdx || selectIdx === 0)) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    }, [selectIdx]);

    return (
        <>
            <Canonical />
            <Helmet>
                <title>{t("seo_friendly.video_gallery.title")}</title>
                <meta name="description" content={t("seo_friendly.video_gallery.desc")} />
            </Helmet>

            <div className='bg-white dark:bg-bgDarkDull'>
                <CorporateBanner title={t("corporate.content_pages.video_gallery.title")} root1={t("corporate.content_pages.photo_gallery.home")} root2={t("corporate.content_pages.photo_gallery.media")} root3={t("corporate.content_pages.video_gallery.title")} />

                <div id="home" className="w-full container pt-[30px] xsm:pt-[40px] xlx:pt-[60px] pb-[60px] xsm:pb-[70px] lg:pb-[90px] xlx:pb-[110px] mms:!px-[30px]">
                    {loading ?
                        <div className="w-full grid grid-cols-1 xlsm:grid-cols-2 msm:grid-cols-3 gap-y-[15px] gap-x-[20px] xlx:gap-[30px]">
                            {Array.isArray(loaderData) && loaderData.map((item: any, index: number) => (
                                <div className="w-full flex flex-col animate-pulse border border-gray-300 dark:border-gray-700 p-[15px]" key={index}>
                                    <div className="flex items-center justify-center w-full h-[225px] bg-gray-300 rounded-sm dark:bg-gray-700">
                                        <svg className="w-[50px] h-[50px] text-gray-200 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 18">
                                            <path className="w-full" d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" />
                                        </svg>
                                    </div>
                                    <div className="flex flex-col gap-[8px] pt-[15px] w-full">
                                        <div className="bg-gray-200 dark:dark:bg-gray-700 rounded-full h-[12px] w-full"></div>
                                        <div className="bg-gray-200 dark:dark:bg-gray-700 rounded-full h-[12px] w-[50%]"></div>
                                    </div>
                                </div>
                            ))}
                        </ div>
                        :
                        <div className="flex flex-col gap-[15px] w-full">
                            {isError ? <Error /> : <>
                                {data?.length > 0 ? <>
                                    <div className="w-full grid grid-cols-1 xlsm:grid-cols-2 msm:grid-cols-3 gap-y-[15px] gap-x-[20px] xlx:gap-[30px]">
                                        {Array.isArray(data) && data.map((item: any, index: number) => (
                                            <button className="w-full flex flex-col border border-[#FFDCDC] dark:border-[#FFDCDC5e] hover:border-primary focus:border-primary dark:hover:border-primary dark:focus:border-primary p-[15px] focus:shadow-[0px_6px_14px_-6px_rgba(24,39,75,0.12),0px_10px_32px_-4px_rgba(24,39,75,0.10)] hover:shadow-[0px_6px_14px_-6px_rgba(24,39,75,0.12),0px_10px_32px_-4px_rgba(24,39,75,0.10)]" key={index} onClick={() => setSelectIdx(index)}>
                                                <img src={item?.thumbnail?.url} alt={item?.name} className="w-full h-[225px]" />

                                                <h5 className="line-clamp-2 text-blackDull dark:text-textBlackDull font-bold text-left pt-[15px]">{item?.name}</h5>
                                            </button>
                                        ))}
                                    </div>
                                    <div className="flex items-center justify-center w-full mt-[10px]">
                                        <PaginationComponent
                                            page={page}
                                            total={totalPages}
                                            setPage={setPage}
                                        />
                                    </div>
                                    {(!!selectIdx || selectIdx === 0) &&
                                        <ModalVideo channel="custom" isOpen={true} url={data?.[selectIdx]?.link} onClose={() => setSelectIdx(null)} />

                                        // <div className="fixed inset-0 z-40 overflow-y-hidden top-0 ">
                                        //     <div
                                        //         className="fixed inset-0 w-full h-full bg-[rgba(171,171,171,0.70)] backdrop-blur-[10px]" onClick={() => setSelectIdx(null)}
                                        //     ></div>
                                        //     <div className="flex justify-center items-center min-h-screen">
                                        //         <div className="relative m-[15px] lg:mx-auto bg-white dark:bg-bgDarkDull rounded-[10px] w-full lg:w-[960px] h-[60vh] shadow-[0px_8px_22px_-6px_rgba(24,39,75,0.12),0px_14px_64px_-4px_rgba(24,39,75,0.12))] pt-[40px]">
                                        //             <button aria-label={t("aria_label.close")} title={t("aria_label.close")} className="rounded-full focus:shadow-[0_0_0_2px_#4e566d5e] hover:shadow-[0_0_0_2px_#4e566d5e] min-w-[23px] h-[23px] flex items-center justify-center bg-[#e4e4e4] dark:bg-[#4c4e5e5e] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e] absolute top-[15px] right-[15px]" autoFocus={true} onClick={() => setSelectIdx(null)}>
                                        //                 <CloseBtn />
                                        //             </button>

                                        //             <div className="w-full h-full p-[15px]">
                                        //                 <iframe
                                        //                     width="100%"
                                        //                     height="100%"
                                        //                     src={data?.[selectIdx]?.link}
                                        //                     frameBorder="0"
                                        //                     allowFullScreen
                                        //                 ></iframe>
                                        //             </div>
                                        //         </div>
                                        //     </div>
                                        // </div>
                                    }
                                </> :
                                    <EmptyList />
                                }
                            </>}
                        </div>}
                </div>
            </div>
        </>
    );
};

export default VideoGallery;